export default __webpack_public_path__ + "static/media/photoshop-logo.e6a1812a.svg";